var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:_vm.summary.type.replace(/^(is-)/, 'has-text-')},[_c('b-icon',{attrs:{"icon":_vm.summary.icon,"type":_vm.summary.type,"size":"is-small"}}),_vm._v(" "),_c(_vm.summary.i18n,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }